import React, { useState } from 'react';

const SortBySelect = () => {
  const [sortBy, setSortBy] = useState('BotanicalName');

  const sortByChanged = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSortBy(value);
  };

  const sortByRendered = (
    <>
      <label>
        <select
          id="product-grid--sort-box"
          onChange={sortByChanged}
          value={sortBy}
        >
          <option value="BotanicalName">Sort by botanic name</option>
          <option value="CommonName">Sort by common name</option>
        </select>
      </label>
    </>
  );

  return [sortBy, sortByRendered];
};
export default SortBySelect;
